// Firebase configuration
import { initializeApp } from 'firebase/app'
import { getFirestore, collection, doc, setDoc, getDoc, increment, query, where, getDocs, orderBy, addDoc, serverTimestamp } from 'firebase/firestore'

const firebaseConfig = {
  apiKey: "AIzaSyAbOiWMWWnZ08tZ0DUnAdxpJmSqrMI6WLI",
  authDomain: "kewaarsaudi.firebaseapp.com",
  projectId: "kewaarsaudi",
  storageBucket: "kewaarsaudi.firebasestorage.app",
  messagingSenderId: "98465138211",
  appId: "1:98465138211:web:ecea3f2cdb05d15f6b1396",
  measurementId: "G-RBHZ982N7M"
}

const app = initializeApp(firebaseConfig)
export const db = getFirestore(app)

// QR Code Management
export const getQRCode = async () => {
  const docRef = doc(db, 'config', 'qrCode')
  const docSnap = await getDoc(docRef)
  if (docSnap.exists()) {
    return docSnap.data()
  }
  // Default QR code
  return {
    url: 'https://kewaar.com',
    size: 250,
    updatedAt: serverTimestamp()
  }
}

export const updateQRCode = async (qrData) => {
  const docRef = doc(db, 'config', 'qrCode')
  await setDoc(docRef, {
    ...qrData,
    updatedAt: serverTimestamp()
  })
}

// Analytics Tracking
export const trackVideoView = async (videoId, videoTitle, watchDuration, isFullView) => {
  try {
    console.log('Tracking video view:', { videoId, videoTitle, watchDuration, isFullView })
    
    const viewData = {
      videoId,
      videoTitle,
      watchDuration,
      isFullView,
      timestamp: serverTimestamp(),
      hour: new Date().getHours(),
      date: new Date().toISOString().split('T')[0]
    }
    
    // Add to views collection
    await addDoc(collection(db, 'videoViews'), viewData)
    console.log('View recorded successfully')
    
    // Update daily stats
    const today = new Date().toISOString().split('T')[0]
    const statsRef = doc(db, 'dailyStats', today)
    
    await setDoc(statsRef, {
      date: today,
      totalViews: increment(1),
      fullViews: increment(isFullView ? 1 : 0),
      [`hourlyViews.${new Date().getHours()}`]: increment(1),
      [`videoStats.${videoId}`]: {
        title: videoTitle,
        views: increment(1),
        fullViews: increment(isFullView ? 1 : 0)
      }
    }, { merge: true })
    console.log('Daily stats updated')
  } catch (error) {
    console.error('Error tracking video view:', error)
    throw error
  }
}

// Get Analytics Data
export const getAnalytics = async (startDate, endDate) => {
  const q = query(
    collection(db, 'dailyStats'),
    where('date', '>=', startDate),
    where('date', '<=', endDate),
    orderBy('date', 'desc')
  )
  
  const querySnapshot = await getDocs(q)
  const stats = []
  querySnapshot.forEach((doc) => {
    stats.push(doc.data())
  })
  return stats
}

// Get peak hours
export const getPeakHours = async (days = 7) => {
  const endDate = new Date()
  const startDate = new Date()
  startDate.setDate(startDate.getDate() - days)
  
  const q = query(
    collection(db, 'dailyStats'),
    where('date', '>=', startDate.toISOString().split('T')[0]),
    where('date', '<=', endDate.toISOString().split('T')[0])
  )
  
  const querySnapshot = await getDocs(q)
  const hourlyTotals = {}
  
  querySnapshot.forEach((doc) => {
    const data = doc.data()
    if (data.hourlyViews) {
      Object.entries(data.hourlyViews).forEach(([hour, count]) => {
        hourlyTotals[hour] = (hourlyTotals[hour] || 0) + count
      })
    }
  })
  
  // Find peak hour
  let peakHour = null
  let maxViews = 0
  Object.entries(hourlyTotals).forEach(([hour, count]) => {
    if (count > maxViews) {
      maxViews = count
      peakHour = hour
    }
  })
  
  return { peakHour, maxViews, hourlyTotals }
}

// Get video statistics
export const getVideoStats = async (days = 7) => {
  const endDate = new Date()
  const startDate = new Date()
  startDate.setDate(startDate.getDate() - days)
  
  const q = query(
    collection(db, 'dailyStats'),
    where('date', '>=', startDate.toISOString().split('T')[0]),
    where('date', '<=', endDate.toISOString().split('T')[0])
  )
  
  const querySnapshot = await getDocs(q)
  const videoStats = {}
  
  querySnapshot.forEach((doc) => {
    const data = doc.data()
    if (data.videoStats) {
      Object.entries(data.videoStats).forEach(([videoId, stats]) => {
        if (!videoStats[videoId]) {
          videoStats[videoId] = {
            title: stats.title,
            totalViews: 0,
            fullViews: 0
          }
        }
        videoStats[videoId].totalViews += stats.views || 0
        videoStats[videoId].fullViews += stats.fullViews || 0
      })
    }
  })
  
  return Object.entries(videoStats).map(([id, stats]) => ({
    id,
    ...stats
  })).sort((a, b) => b.totalViews - a.totalViews)
}
